export default __webpack_public_path__ + "static/media/transactions-list-is-empty.ce10d6f3.png";